module.exports = __webpack_public_path__ + "img/03.96de436c.png";